<template>
    <el-container  >
        <el-row class="log">

            <el-col style="height: 100vh;position: absolute;left: 50%;transform: translate(-50%,0)">
                <img src="@/assets/basic/logo.png" style="position: relative;transform:translate(-50%,0);top: 18rem;left: 50%">

                <el-row style="position: relative;top: 50%;transform: translate(0,-50%)">
                    <img src="@/assets/basic/login_center.png" style="position: absolute;top: 50%;left: 50%;transform: translate(-50%,-50%)">
                    <img src="@/assets/basic/login_left.png" style="position: absolute;top: 50%;transform: translate(-50%,-50%);left: calc(50% - 48rem)">
                    <img src="@/assets/basic/login_right.png" style="position: absolute;top: 50%;transform: translate(-50%,-50%);left: calc(50% + 48rem)">

                    <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form">
                        <el-form-item prop="userName">
                            <el-input v-model="loginForm.userName"  autocomplete="off"  placeholder="请输入账号">
                                 <span slot="prefix" style="color: #707071;">
                                 <img src="../assets/basic/log-zh.png" class=" log_ico_code">
<!--                                 <el-divider direction="vertical" content-position="left" class="log_ico_code_dir"></el-divider>-->
                              </span>
                            </el-input>
                        </el-form-item>
                        <el-form-item prop="password">
                            <el-input v-model="loginForm.password"  type="password"  auto-complete="off"
                                      placeholder="请输入密码"
                                      @keyup.enter.native="handleLogin"
                            >
                                 <span slot="prefix" >
                                 <img src="../assets/basic/log-ma.png" class=" log_ico_code">
                              </span>
                            </el-input>

                        </el-form-item>
                        <el-form-item prop="verifyCode">
                            <el-input v-model="loginForm.verifyCode"  autocomplete="off"
                                      placeholder="请输入验证码"
                                      @keyup.enter.native="handleLogin"
                            >
                                 <span slot="prefix" style="color: #707071;">
                                 <img src="../assets/basic/log-yzm.png" class=" log_ico_code">
                              </span>
                            </el-input>
                            <div class="login-code">
                                <img :src="codeUrl" @click="getCode" class="login-code-img"/>
                            </div>
                        </el-form-item>
                        <el-checkbox v-model="loginForm.rememberMe" style="padding:5px 5px;color:#FFFFFF ">记住密码</el-checkbox>
                        <el-form-item style="width:100%;">
                            <el-button
                                    :loading="loading"
                                    size="medium"
                                    type="primary"
                                    style="width:100%;"
                                    @click.native.prevent="handleLogin"
                                    class="log_mn_right_log">
                                <span v-if="!loading">登 录</span>
                                <span v-else>登 录 中...</span>
                            </el-button>
                        </el-form-item>
                    </el-form>
                </el-row>
                <el-row style="font-size: 14px;color: #FFFFFF;position: absolute;transform: translate(-50%,0);bottom: 5rem;left: 50%">
                    Copyright © 2024 ©北京瀚禹信息科技有限公司
                </el-row>
            </el-col>

        </el-row>

    </el-container>
</template>

<script>

import Cookies from "js-cookie";
import md5 from 'js-md5';
import {setRoutes} from "@/router";

export default {
    name: "Login",
    data() {
        return {
            codeUrl: "",
            loginForm: {
                userName: "",
                password: "",
                rememberMe: false,
                verifyCode: "",
                codeId:"",
            },
            loginRules: {
                userName: [
                    { required: true, trigger: "blur", message: "请输入您的账号" }
                ],
                password: [
                    { required: true, trigger: "blur", message: "请输入您的密码" }
                ],
                verifyCode: [{ required: true, trigger: "blur", message: "请输入验证码" },
                    {trigger: "blur",min: 4, max: 4,message: "验证码长度必须为4"}]
            },
            loading: false,
        };
    },
  created() {
      this.getCode();
      this.getCookie();
      //this.getLoginState();
  },
  methods: {

      getCode(){
          this.request.get("/rm-suser/v1/verify-code").then(res => {
              this.codeUrl =res.data.codeImgBase64;
              this.loginForm.codeId = res.data.codeId;
          })
      },

      getCookie(){
          const userName = Cookies.get("userName");
          const password = Cookies.get("password");
          const rememberMe = Cookies.get('rememberMe')
          this.loginForm = {
              userName: userName === undefined ? this.loginForm.userName : userName,
              password: password === undefined ? this.loginForm.password : password,
              rememberMe: rememberMe === undefined ? false : Boolean(rememberMe)
          };
      },
      getLoginState(){
         /* const token =localStorage.getItem("token");
          //console.log("localStorage",localStorage)
          if(token){
              this.$router.replace("/")
          }*/
      },
      //失败重置验证码
      resetAll(){
          this.$set( this.loginForm,'verifyCode','')
          this.getCode();
      },
      handleLogin() {
          // if(typeof this.loginForm.verifyCode === 'undefined'){
          //     return
          // }
          // if(this.loginForm.verifyCode.length !== 4){
          //     return
          // }
          this.$refs.loginForm.validate(valid => {
                //console.log("valid",valid)
              if (valid) {  // 表单校验合法
                  this.loading = true;
                /*    if(this.loginForm.mm.length != 32){
                      this.loginForm.mm = md5(this.loginForm.mm)
                    }*/
                  if (this.loginForm.rememberMe) {
                      Cookies.set("userName", this.loginForm.userName, { expires: 30 });
                      Cookies.set("password", this.loginForm.password, { expires: 30 });
                      Cookies.set('rememberMe', this.loginForm.rememberMe, { expires: 30 });
                  }else{
                      Cookies.remove("userName");
                      Cookies.remove("password");
                      Cookies.remove('rememberMe');
                  }
                 // this.loginForm.password = md5(this.loginForm.password)
                  let loginForm = {
                      ...this.loginForm,
                      password:md5(this.loginForm.password)
                  }
                  this.request.post("/rm-suser/v1/login",loginForm).then(
                      res=>{
                          if(res.ok){
                              localStorage.setItem("token",res.data)
                              this.$store.commit('RESET_STATE')
                              // 动态设置当前用户的路由
                              this.request.get("/rm-smodule/v1/tree",{}).then(res2=>{
                                  if(res2.data.length){
                                      localStorage.setItem("menus", JSON.stringify(res2.data))
                                      this.request.get("/rm-suser/v1/loginUser",{}).then(res=>{
                                          if(res.ok){
                                              if(res.data.resList !==null && res.data.resList.length > 0){
                                                  let skList = res.data.resList
                                                  localStorage.setItem("skName", skList[0].resName)
                                                  localStorage.setItem("skCd", skList[0].rescd)
                                                localStorage.setItem("md", res.data.md)
                                                  //存储每个水库经纬度
                                                let arr=[];
                                                for (let i = 0; i < skList.length; i++) {
                                                  arr.push({
                                                    sKCd:skList[i].rescd,
                                                    lgtd:skList[i].lgtd,
                                                    lttd:skList[i].lttd,
                                                  })
                                                }
                                                localStorage.setItem("lntArr", JSON.stringify(arr));
                                                  setRoutes()

                                                  this.$router.push("/")
                                                  this.$message.success("登录成功")
                                              }else{
                                                this.loading=false;
                                                this.$message.error("水库信息权限不足");
                                              }

                                          }
                                      })
                                  }else{
                                      this.resetAll();
                                      this.loading = false;
                                      this.$message.info("请联系管理员更改权限！")
                                  }

                              })

                          }else{
                              this.resetAll();
                              this.loading = false;
                              this.$message.error(res.error.message)
                          }
                      }
                  )
              }
          });
      },
  },
    mounted() {
        /*const video = document.getElementById("startvideo");
        //调用video标签的播放函数
        video.play();*/
    }
}
</script>

<style lang="less" scoped>
/deep/ .el-form-item__error{
    top: unset;
}
// 改变input里的字体颜色
/deep/input::-webkit-input-placeholder {
    color: #17a1e5;
    font-size: 15px;
}
/deep/ .el-select {
    position: relative;
    /** 修改输入框透明及选择完字体颜色更改*/
    .el-input {
        input {
            border-color: #235FA7;
            color: #00D4FF;
        }
    }
}
/deep/ .el-input__inner{
  height: 5.5rem;
  //border-radius: 1.8rem;
  font-size: 2rem;
  line-height: 2rem;
  background-color: #1B4B9A !important;
  padding-left:6rem;
  font-weight: 500;
    border: 1px solid #2260a7;
    color: #ffffff;
}
/deep/ .el-input__inner::placeholder {
    color: #FFFFFF;
}
/deep/ .el-input__prefix{
  left:10px;
  height: 0;
}
/deep/.el-carousel__button{
  background-color: #28cdfd;
  height: 1rem;
}

.log{
    width: 100vw;
    height: 100vh;
    //background-color: #052062;
    //opacity: 0.47;
    background-image: url("../assets/basic/sk.jpg");
    //background-size: contain;
    background-repeat: no-repeat;
}
.log_mn_right_log{
  margin-top: 2rem;
  border-radius: 0.8rem;
  height: 6rem;
  font-size: 1.6rem;
    background-color: #2c83ea
}
/deep/.el-form-item{
    height: 6rem;
}
.log_ico_code{
  margin: 12px 15px ;
  width: 2.4rem;
}
.log_ico{
  font-size: 3rem;
  margin: 8px 12px ;
}
.log_mn_left_car{
  padding-left: 10rem;
}
.log_whole{
  background-image: url("../assets/images/loginBg.png");
  background-size: cover;
  display: flex;
}
  .login {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 84.5vh;
    background-size: cover;
  }
  .login-form {
    border-radius: 2rem;
    width: 50rem;
    position: relative;
    transform: translate(-50%,0);
    left: 50%;
    top: 1rem;
  }
  .login-code {
    position: relative;
    width: 30%;
    height: 5rem;
    float: right;
    top: -5.3rem;
    left: -1rem;
    img {
      cursor: pointer;
      vertical-align: middle;
      width: 100%;
      height: 100%;
    }
  }
</style>

